import { forwardRef } from 'react';
import Box from '@mui/material/Box';

import { TextAreaProps } from './TextArea.types';
import { CharacterCounter } from './CharacterCounter';
import { TextAreaStyled } from './TextArea.styled';

export const TextArea = forwardRef<HTMLDivElement, TextAreaProps>((props: TextAreaProps, ref) => {
  const { helperText, charLimit, error, ...rest } = props;

  const charsLength = rest.value?.length;
  let isTextOverflow = false;
  let textAreaError = error;

  if (charsLength && charLimit) {
    isTextOverflow = charsLength > charLimit;
    if (isTextOverflow) {
      textAreaError = true;
    }
  }

  return (
    <TextAreaStyled
      error={textAreaError}
      helperText={
        <Box component="span" sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <span>{helperText}</span>
          <CharacterCounter charLimit={charLimit} charsLength={charsLength} isTextOverflow={isTextOverflow} />
        </Box>
      }
      minRows={5}
      multiline={true}
      ref={ref}
      {...rest}
      InputLabelProps={
        rest.hiddenLabel ? { ...rest.InputLabelProps, className: 'sr-only' } : rest.InputLabelProps
      }
    />
  );
});

TextArea.displayName = 'TextArea';
